// extracted by mini-css-extract-plugin
module.exports = {"ActionItem":"CorporateActions_ActionItem__YaEIW","ActionLoaderItem":"CorporateActions_ActionLoaderItem__3Aj9y"};